import React, { useEffect } from 'react'
import { Router, Switch, Route } from 'react-router-dom'
import SupplierSignUp from 'containers/SupplierSignUp'
import UserSignIn from 'containers/UserSignIn'
import DocumentationPage from 'containers/DocumentationPage'
import PublicCustomerOrderPage from 'containers/PublicCustomerOrderPage'
import PublicPayPalPaymentPage from 'containers/PublicPayPalPaymentPage'
import PublicLiveSessionRedirectPage from 'containers/PublicLiveSessionRedirectPage'
import CustomerFeedbackPage from 'containers/CustomerFeedbackPage'
import PublicSupplierConsentPage from 'containers/PublicSupplierConsentPage'

const Redirect =(props) => {
  useEffect(() => {
    window.location = `/?redirect=${encodeURI(props.history.location.pathname)}`
  }, [])

  return null
}

const PublicApp = (props) => {
  return (
  <Router {...props}>
    <Switch>
      <Route path="/feedback/:hash" component={CustomerFeedbackPage} />
      <Route path="/consent/:hashId" component={PublicSupplierConsentPage} />
      <Route path="/s/:hashId" component={PublicCustomerOrderPage} />
      <Route path="/paypal/:hashId" component={PublicPayPalPaymentPage} />
      <Route path="/ls/:hashId" component={PublicLiveSessionRedirectPage} />
      <Route path="/user/*" component={UserSignIn} />
      <Route path="/talent/sign-up" component={SupplierSignUp} />
      <Route path="/docs/*" component={DocumentationPage} />
      <Route path="*">
        <Redirect {...props} />
      </Route>
    </Switch>
  </Router>
)
}

export default PublicApp
